import React from 'react';
import FormSection from '../../FormElements/FormSection';
import Subtitle from '../../FormElements/Subtitle';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import TextArea from '../../FormElements/TextArea';
import TextEditor from '../../TextEditor/TextEditor';
import EmailInput from '../../FormElements/EmailInput';
import Switch from '../../FormElements/Switch';
import FormSubmit from '../../FormElements/FormSubmit';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import GlobalInfoAlert from '../../Alerts/GlobalInfoAlert';
import OrganizationSelectbox from '../../FormElements/OrganizationSelectbox';
import { HexColorPicker } from 'react-colorful';

export default class EditAccountForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			accountName: '',
			publicId: '',
			legacyId: '',
			apiKey: '',
			channelId: '',
			classroomName: '',
			classroomWelcomeText: '',
			isDeluxeUIEnabled: '',
			isLearningPlanModeEnabled: '',

			isLoginRequired: '',
			isInteractiveSignInEnabled: '',
			isSsoRequired: '',
			ssoLoginRedirectUrl: '',
			defaultLandingPage: '',
			isAssessmentScoreDisplayed: '',
			isPreTestRequired: '',
			isPostTestRequired: '',
			searchDisplay: '',
			notLoggedInMessage: '',
			allCoursesMessage: '',
			myCoursesMessage: '',
			coursePreview: '',
			courseImageCollectionId: '',
			collapsibleCourseCollectionGroups: '',
			isHelpVisible: '',
			isVideoEnabled: '',

			brandPrimaryColor: '',
			brandLinkColor: '',
			footerText: ''
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.loadData = this.loadData.bind(this);
	}

	componentDidMount() {
		console.log('about to load data...');
		this.loadData();
	}

	componentDidUpdate(prevProps, prevState) {
		console.log('prevProps', prevProps);
		if (prevProps.get_account_endpoint !== this.props.get_account_endpoint) {
			console.log('about to load data...');
			this.loadData();
		}
	}

	render() {
		// console.log(
		// 	'Edit Account Form - Props',
		// 	this.props
		// 'Edit Account Form - State',
		// this.state
		// );
		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						<Subtitle
							classname="mt-2 font-weight-bold"
							subtitle={I18n.t('admin.account.subtitle_general')}
						/>
						<Label>{I18n.t('admin.account.account_name')}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.account_name')}
							name="accountName"
							value={this.state.accountName}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{I18n.t('admin.account.public_id')}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.public_id')}
							name="publicId"
							value={this.state.publicId}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{I18n.t('admin.account.legacy_id')}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.legacy_id')}
							name="legacyId"
							value={this.state.legacyId}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{I18n.t('admin.account.api_key')}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.api_key')}
							name="apiKey"
							value={this.state.apiKey}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{I18n.t('admin.account.channel_id')}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.channel_id')}
							name="channelId"
							value={this.state.channelId}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{I18n.t('admin.account.classroom_name')}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="classroomName"
							value={this.state.classroomName}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{I18n.t('admin.account.classroom_welcome_text')}</Label>
						<TextArea
							placeholder={I18n.t('admin.account.classroom_welcome_text')}
							name="classroomWelcomeText"
							value={this.state.classroomWelcomeText}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Subtitle subtitle={I18n.t('admin.account.subtitle_settings')} />
						<Label>{I18n.t('admin.account.deluxe_ui_enabled')}</Label>
						<Switch
							isOn={this.state.isDeluxeUIEnabled}
							handleToggle={() =>
								this.setState({
									isDeluxeUIEnabled: !this.state.isDeluxeUIEnabled
								})}
						/>
						<Label>{I18n.t('admin.account.learning_plan_mode')}</Label>
						<Switch
							isOn={this.state.isLearningPlanModeEnabled}
							handleToggle={() =>
								this.setState({
									isLearningPlanModeEnabled: !this.state
										.isLearningPlanModeEnabled
								})}
						/>

						<Label>{"I18n.t('admin.account.login_required')"}</Label>
						<Switch
							isOn={this.state.isLoginRequired}
							handleToggle={() =>
								this.setState({
									isLoginRequired: !this.state.isLoginRequired
								})}
						/>
						<Label>
							{"I18n.t('admin.account.interactive_sign_in_required')"}
						</Label>
						<Switch
							isOn={this.state.isInteractiveSignInEnabled}
							handleToggle={() =>
								this.setState({
									isInteractiveSignInEnabled: !this.state
										.isInteractiveSignInEnabled
								})}
						/>
						<Label>{"I18n.t('admin.account.sso_required')"}</Label>
						<Switch
							isOn={this.state.isSsoRequired}
							handleToggle={() =>
								this.setState({
									isSsoRequired: !this.state.isSsoRequired
								})}
						/>
						<Label>{"I18n.t('admin.account.sso_login_redirect_url')"}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="ssoLoginRedirectUrl"
							value={this.state.ssoLoginRedirectUrl}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{"I18n.t('admin.account.default_landing_page')"}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="defaultLandingPage"
							value={this.state.defaultLandingPage}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{"I18n.t('admin.account.display_assessment_score')"}</Label>
						<Switch
							isOn={this.state.isAssessmentScoreDisplayed}
							handleToggle={() =>
								this.setState({
									isAssessmentScoreDisplayed: !this.state
										.isAssessmentScoreDisplayed
								})}
						/>
						<Label>{"I18n.t('admin.account.pre_test_required')"}</Label>
						<Switch
							isOn={this.state.isPreTestRequired}
							handleToggle={() =>
								this.setState({
									isPreTestRequired: !this.state.isPreTestRequired
								})}
						/>
						<Label>{"I18n.t('admin.account.post_test_required')"}</Label>
						<Switch
							isOn={this.state.isPostTestRequired}
							handleToggle={() =>
								this.setState({
									isPostTestRequired: !this.state.isPostTestRequired
								})}
						/>
						<Label>{"I18n.t('admin.account.search_display')"}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="searchDisplay"
							value={this.state.searchDisplay}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{I18n.t('admin.account.not_logged_in_message')}</Label>
						<TextEditor
							placeholder={I18n.t('admin.account.classroom_welcome_text')}
							name="notLoggedInMessage"
							value={this.state.notLoggedInMessage}
							onChange={this.onChange}
							height={250}
						/>
						<Label>{I18n.t('admin.account.all_courses_message')}</Label>
						<TextEditor
							placeholder={I18n.t('admin.account.classroom_welcome_text')}
							name="allCoursesMessage"
							value={this.state.allCoursesMessage}
							onChange={this.onChange}
							height={250}
						/>
						<Label>{I18n.t('admin.account.my_courses_message')}</Label>
						<TextEditor
							placeholder={I18n.t('admin.account.classroom_welcome_text')}
							name="myCoursesMessage"
							value={this.state.myCoursesMessage}
							onChange={this.onChange}
							height={250}
						/>
						<Label>{"I18n.t('admin.account.course_preview')"}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="coursePreview"
							value={this.state.coursePreview}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>
							{"I18n.t('admin.account.course_image_collection_id')"}
						</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="courseImageCollectionId"
							value={this.state.courseImageCollectionId}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>
							{"I18n.t('admin.account.collapsible_course_collection_groups')"}
						</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="collapsibleCourseCollectionGroups"
							value={this.state.collapsibleCourseCollectionGroups}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{"I18n.t('admin.account.help_visible')"}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="isHelpVisible"
							value={this.state.isHelpVisible}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
						<Label>{"I18n.t('admin.account.video_enabled')"}</Label>
						<TextInput
							placeholder={I18n.t('admin.account.classroom_name')}
							name="isVideoEnabled"
							value={this.state.isVideoEnabled}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>

						<Subtitle subtitle="Branding" />
						<Label>{I18n.t('admin.account.brand_primary_color')}</Label>
						<HexColorPicker color={this.state.brandPrimaryColor} />
						<Label>{I18n.t('admin.account.brand_link_color')}</Label>
						<HexColorPicker color={this.state.brandLinkColor} />
						<Subtitle subtitle={I18n.t('admin.account.subtitle_footer')} />
						<Label>{I18n.t('admin.account.footer_text')}</Label>
						<TextArea
							placeholder={I18n.t('admin.account.footer_text')}
							name="footerText"
							value={this.state.footerText}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
						/>
					</FormSection>
					<FormSubmit text="Save Changes" />
				</form>
				{this.state.loading ? (
					<div
						className="loadingOverlay"
						style={
							this.props.overlay_color ? (
								{ backgroundColor: this.props.overlay_color }
							) : (
								{}
							)
						}
					>
						<div className="spinner" />
					</div>
				) : null}
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true,
			globalErrors: null,
			fieldErrors: null
		});

		$.ajax({
			type: 'POST',
			url: this.props.get_account_endpoint,
			data: {
				name: this.state.accountName,
				account_id: this.state.publicId,
				legacy_id: this.state.legacyId,
				api_key: this.state.apiKey,
				channel_id: this.state.channelId,
				classroom_name: this.state.classroomName,
				classroom_text: this.state.classroomWelcomeText,
				user_tracking_enabled: this.state.isDeluxeUIEnabled,
				learning_plan_mode: this.state.isLearningPlanModeEnabled,

				login_required: this.state.isLoginRequired,
				interactive_sign_in_enabled: this.state.isInteractiveSignInEnabled,
				sso_required: this.state.isSsoRequired,
				sso_login_redirect_url: this.state.ssoLoginRedirectUrl,
				default_landing_page: this.state.defaultLandingPage,
				display_assessment_score: this.state.isAssessmentScoreDisplayed,
				pre_test_required: this.state.isPreTestRequired,
				post_test_required: this.state.isPostTestRequired,
				search_display: this.state.searchDisplay,
				not_logged_in_message: this.state.notLoggedInMessage,
				all_courses_message: this.state.allCoursesMessage,
				my_courses_message: this.state.myCoursesMessage,
				course_preview: this.state.coursePreview,
				course_image_collection_id: this.state.courseImageCollectionId,
				collapsible_course_collection_groups: this.state
					.collapsibleCourseCollectionGroups,
				help_visible: this.state.isHelpVisible,
				video_enabled: this.state.isVideoEnabled,

				brand_primary_color: this.state.brandPrimaryColor,
				brand_link_color: this.state.brandLinkColor,
				footer_text: this.state.footerText
			},
			dataType: 'json'
		}).done((data) => {
			console.log('Done!', data);
			if (data.success == true) {
				// console.log('Account successfully updated!', data);
				this.setState({
					loading: false
				});
				this.props.onHidePopup();
				this.props.onShowSuccessCardPopup();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				// console.log('Account update failed!');
				this.setState({
					loading: false
				});
			}
		});
	}

	loadData() {
		$.ajax({
			type: 'GET',
			url: this.props.get_account_endpoint
		}).done((payload) => {
			const result = payload;
			// console.log('Account data loaded!', result);
			this.setState({
				accountName: result.data.name,
				publicId: result.data.public_id,
				legacyId: result.data.legacy_id,
				apiKey: result.data.api_key,
				channelId: result.data.channel_id,
				classroomName: result.data.classroom_name,
				classroomWelcomeText: result.data.classroom_text,
				isDeluxeUIEnabled: result.data.user_tracking_enabled,
				isLearningPlanModeEnabled: result.data.learning_plan_mode,

				isLoginRequired: result.data.login_required,
				isInteractiveSignInEnabled: result.data.interactive_sign_in_enabled,
				isSsoRequired: result.data.sso_required,
				ssoLoginRedirectUrl: result.data.sso_login_redirect_url,
				defaultLandingPage: result.data.default_landing_page,
				isAssessmentScoreDisplayed: result.data.display_assessment_score,
				isPreTestRequired: result.data.pre_test_required,
				isPostTestRequired: result.data.post_test_required,
				searchDisplay: result.data.search_display,
				notLoggedInMessage: result.data.not_logged_in_message,
				allCoursesMessage: result.data.all_courses_message,
				myCoursesMessage: result.data.my_courses_message,
				coursePreview: result.data.course_preview,
				courseImageCollectionId: result.data.course_image_collection_id,
				collapsibleCourseCollectionGroups:
					result.data.collapsible_course_collection_groups,
				isHelpVisible: result.data.help_visible,
				isVideoEnabled: result.data.video_enabled,

				brandPrimaryColor: result.data.brand_primary_color,
				brandLinkColor: result.data.brand_link_color,
				footerText: result.data.footer_text,
				loading: false
			});
		});
	}
}
